import { Expose, Type } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';

import { SnBaseLayer } from './base-layer';
import { SnLayerMeta } from './layer-meta';
import { SnLayerType } from './layer-type';

export class EsriQueryLayerMeta extends SnLayerMeta {
  @Expose()
  public readonly queryInterval: number;

  @Expose()
  public readonly isMainCAD: boolean;

  @Expose()
  public readonly isMainCaD: boolean;

  @Expose()
  public readonly translateGaTech: boolean;

  @Expose()
  public readonly dynamic: boolean;

  @Expose()
  public readonly fields: string[];

  @ExposeRawData()
  public readonly filters: any;

  @Expose()
  public readonly idleTimeout: number = 10;

  @Expose()
  public isPubSub: boolean;

  @Expose()
  public search: string;
}

export class SnEsriQueryLayer extends SnBaseLayer {
  @Expose({ name: 'streamDefinitionUrl' })
  public definitionUrl: string;

  @Expose()
  @Type(() => EsriQueryLayerMeta)
  public meta: EsriQueryLayerMeta;

  public readonly type = SnLayerType.EsriQuery;
}
